import { useState, useEffect, useCallback } from 'react';

type SnapPoint = number;

export function useCoachPanel() {
  const [isOpen, setIsOpen] = useState(false);
  const [snap, setSnap] = useState<SnapPoint>(0);

  const open = useCallback(() => {
    setIsOpen(true);
    setSnap(1);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setSnap(0);
  }, []);

  const toggle = useCallback(() => {
    if (isOpen) close();
    else open();
  }, [isOpen, close, open]);

  // Cmd/Ctrl+K shortcut
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        toggle();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [toggle]);

  return { isOpen, snap, setSnap, open, close, toggle };
}
